<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title" *ngIf="inner_Evaluate.id==0">Add Review Question Form</h5>
      <h5 class="card-title" *ngIf="inner_Evaluate.id>0">Edit Review Question Form</h5>
      <form [formGroup]="FormEvaluate" >

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Title</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">Enter the title.</small>
          </div>
          <div class="form-group col-md-6" [hidden]="inner_Evaluate.id>0">
            <label for="exampleInputEmail1">Type</label>
            <select formControlName="Type" class="custom-select">
              <option value="0">Select</option>
              <option value="1">Select One Item</option>
              <option value="2">Type</option>
            </select>
          </div>
        </div>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      </form>

      <br/>
      <hr/>
      <br/>

      <div [hidden]="get_Form_Type().value!='1'">

        <h5> Options </h5>

        <br />

        <form>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> Option Title : </label>
              <input [(ngModel)]="Option_Input" name="Option_Input" type="text" class="form-control"
                placeholder="Type here...">
            </div>
          </div>

          <button type="button" (click)="Option_Submit()" class="btn btn-danger" style="margin-right: 5px;"><i
              class="fa  fa-plus-circle"></i> Add Option </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="Option.length>0">

          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Option</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Option">
                <td>{{Option.indexOf(item)+1}}</td>
                <td>{{item}}</td>
                <td style="cursor: pointer;">
                  <a style="cursor: pointer;" (click)="Option_Delete(Option.indexOf(item))"
                    class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

        <br />
        <br />

        <br/>
        <hr/>
        <br/>
      </div>


      <button *ngIf="!InProccessing && inner_Evaluate.id==0" type="button" (click)="SubmitFormEvaluate()" [disabled]="!FormEvaluate.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
      <button *ngIf="!InProccessing && inner_Evaluate.id>0" type="button" (click)="SubmitFormEvaluate()" [disabled]="!FormEvaluate.valid" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit </button>
  </div>
</div>
